









































































































import Vue from 'vue';
import { BTable, BvTableField } from 'bootstrap-vue';
import js2excel from 'js2excel';

import BaseCell from '@/components/Table/BaseCell.vue';
import BaseSubTable from '@/components/Table/BaseSubTable.vue';
import ModalConfirm from '@/components/Form/ModalConfirm.vue';

export default Vue.extend({
    name: 'BaseTable',
    components: {
        BaseCell,
        BaseSubTable,
        ModalConfirm,
    },
    props: {
        /** Набор значений */
        items: {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        /** Описание полей */
        fields: {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        /** Заголовок таблицы */
        tableTitle: {
            type: String,
            required: false,
        },
        /** флаг загрузки */
        busy: {
            type: Boolean,
            required: false,
            default: false
        },
        /** Разделение на страницы */
        pagination: {
            type: Boolean,
            required: false,
            default: true
        },
        /** флаг неудачной загрузки */
        loadFail: {
            type: Boolean,
            required: false,
            default: false
        },
        /** Первичный ключ сущности таблицы */
        primaryKey: {
            type: String,
            required: false
        },
        /** Разрешение на экспорт в эксел */
        isExcelable: {
            type: Boolean,
            required: false,
            default: false
        },
        /** Разрешение на редактирование */
        isEditable: {
            type: Boolean,
            required: false,
            default: false
        },
        /** Имя списка для отображении в детализации */
        detailArrayName: {
            type: String,
            required: false
        },
        /** Описание полей таблицы детализации */
        detailFields: {
            type: Array,
            required: false,
        },
        /** Упрвление активностью кнопки создания */
        disableCreate: {
            type: Boolean,
            required: false,
            default: false,
        },
        /** Поле первичной сортировки */
        sortBy: {
            type: String,
            required: false,
        },
        /** Направление первичной сортировки */
        sortDesc: {
            type: Boolean,
            required: false,
        },
    },
    methods: {
        onRowSelected(items: Array<any>): void {
            if (items !== undefined && items.length > 0) {
                this.selected = items[0];
            } else {
                this.selected = undefined;
            }
        },
        editModalShow(): void {
            if (this.selected !== undefined)
                this.$emit('edit-modal-show', this.selected);
        },
        newModalShow(): void {
            this.$emit('new-modal-show');
        },
        deleteModalShow(): void {
            if (this.selected !== undefined)
                this.$emit('delete-modal-show', this.selected);
        },
        onRowDblClick(object: any, index: number): void {
            (this.$refs.selectableTable as BTable).clearSelected();
            (this.$refs.selectableTable as BTable).selectRow(index);
            this.selected = object;
            this.editModalShow();
        },
        excelExport(): void {
            this.excelShow = true;
        },
        excelExportAction(): void {
            try {
                /// Да простят меня боги за этот код
                const printData = new Array<any>();
                const fildsArray = this.fields as Array<
                    { key: string } & BvTableField
                >;
                this.visibleRows.forEach(element => {
                    const newRow = {} as any;
                    fildsArray.forEach( field => {
                        if (element[field.key] !== undefined) {
                            if (typeof element[field.key] === 'boolean') {
                                newRow[field.key] = element[field.key]
                                    ? 'Да'
                                    : 'Нет';
                            } else {
                                newRow[field.key] = element[field.key];
                            }
                        }
                    });
                    printData.push(newRow);
                });
                js2excel.json2excel({
                    data: printData,
                    name: 'export-data',
                    formateDate: 'yyyy/mm/dd'
                });
            } catch (e) {
                console.error('export error');
            }
            this.excelShow = false;
        },
        closeExcel(): void {
            this.excelShow = false;
        },
        isDetailableCell(fieldKey: string): boolean {
            if (this.fields.length > 0) {
                const field = this.fields[0] as any;
                if (field['key'] !== undefined) {
                    return field['key'] === fieldKey && this.hasDetail;
                }
            }
            return false;
        },
        expandDetails(rowObj: any) {
            if (this.hasDetail) {
                if (
                    rowObj[this.detailArrayName] === undefined ||
                    rowObj[this.detailArrayName].length === 0
                ) {
                    this.$emit('load-sub-data', rowObj);
                }
                rowObj._showDetails = !rowObj._showDetails;
            }
        },
        gridRefresh() {
            (this.$refs.selectableTable as BTable).refresh();
        },
    },
    computed: {
        rowsCount(): number {
            return this.items.length;
        },
        paginationAbalible(): boolean {
            return this.perPage < this.rowsCount && this.pagination;
        },
        isToolbar(): boolean {
            return this.isEditable || this.isExcelable;
        },
        perPage(): number {
            return this.pagination ? 10 : 10000000;
        },
        hasDetail(): boolean {
            return (
                this.detailArrayName !== undefined &&
                this.detailFields !== undefined
            );
        },
        excelDisable(): boolean {
            return this.visibleRows.length === 0;
        },
        hasTitle(): boolean {
            return this.tableTitle !== undefined && this.tableTitle !== '';
        },
    },
    data() {
        return {
            visibleRows: [],
            currentPage: 1,
            selected: undefined as any | undefined,
            excelShow: false,
        };
    }
});
